import React from 'react';
import SelectField from './selectfield';
import { translate } from 'utils/common';

class GroupSearchV2 extends React.Component {
    constructor(props) {
        super(props);
        this.selectType = this.selectType.bind(this);
        this.searchKeyPress = this.searchKeyPress.bind(this);
        this.triggerChange = this.triggerChange.bind(this);
        this.state = {
            selectedType: this.props.isDropDownRequired ? this.props.options[0].value: null
        };
    }

    selectType(e) {
        this.setState({ selectedType: e.target.value }, () => {
           // this.triggerChange()
        });
    }

    searchKeyPress(e) {
        if (e.key == 'Enter') {
            e.preventDefault();
            this.triggerChange();
        }
    }
    triggerChange() {
        if (this.props.onChange) {
            this.props.onChange({ target: { 'type': this.state.selectedType, 'value': this.props.value } });
        }
    }
    render() {
        const { options, inputGroupCustomClass, placeholder } = this.props;
        const selectOptions = options.map(s => {
            return { ...{ text: s.label }, ...s };
        })
        const { selectedType } = this.state;
        var selectedOption = this.props.options.filter(item => item.value == selectedType)[0]
        return (
            <div className="group-search">
                <div className="group-search-field d-flex">
                    {this.props.isDropDownRequired && <SelectField options={selectOptions} value={selectedOption.value} onChange={this.selectType} />}
                    <div className="input-group" >
                        <input id='input' onKeyPress={this.searchKeyPress}
                            onChange={event => { this.props.onInputChange(event.target.value)}}
                            type="text" className={'form-control' + (this.props.isDropDownRequired ? '' : ' border-w-1')}
                            placeholder={translate(placeholder)} value={this.props.value}/>

                        <div className="input-group-append">
                            <a onClick={this.triggerChange} className="btn"><i className="fas fa-search"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GroupSearchV2;
